import { render, staticRenderFns } from "./CustomerCommercialContract.vue?vue&type=template&id=06d0014a&scoped=true"
import script from "./CustomerCommercialContract.vue?vue&type=script&lang=js"
export * from "./CustomerCommercialContract.vue?vue&type=script&lang=js"
import style0 from "./CustomerCommercialContract.vue?vue&type=style&index=0&id=06d0014a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0014a",
  null
  
)

export default component.exports